export class LoginEntity {
  userName;
  password;

  constructor(userName = "", password = "") {
    this.userName = userName;
    this.password = password;
  }
}
